/* Live Liquid cards, complete Shopify pagination, no copied catalog or prices. */
(() => {
  const selector = '[data-wfod-discovery]';
  const fold = value => String(value || '').normalize('NFKC').toLocaleLowerCase().trim();
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const controls = root.querySelector('[data-controls]');
    const brand = root.querySelector('[data-brand]');
    const collection = root.querySelector('[data-collection]');
    const color = root.querySelector('[data-color]');
    const reset = root.querySelector('[data-reset]');
    const status = root.querySelector('[data-status]');
    const results = root.querySelector('[data-results]');
    const pagination = root.querySelector('[data-pagination]');
    const empty = root.querySelector('[data-empty]');
    const locationURL = new URL(window.location.href);
    const preview = locationURL.searchParams.get('preview_theme_id');
    const requestedVendor = root.dataset.currentVendor ||
      (locationURL.pathname === '/collections/vendors' ? (locationURL.searchParams.get('q') || '') : '');
    const brandRoutes = [...root.querySelectorAll('[data-brand-route]')];
    const currentVendor = brandRoutes.find(a => fold(a.dataset.brandRoute) === fold(requestedVendor))?.dataset.brandRoute || requestedVendor;
    function preservePreview(container) {
      if (!preview) return;
      container.querySelectorAll('a[href]').forEach(a => {
        const url = new URL(a.getAttribute('href'), locationURL);
        if (url.origin !== locationURL.origin) return;
        url.searchParams.set('preview_theme_id', preview);
        a.href = url.pathname + url.search + url.hash;
      });
    }
    preservePreview(root);
    controls.hidden = false;
    status.textContent = root.dataset.loading;
    root.setAttribute('aria-busy', 'true');
    const option = (value, label) => new Option(label, value);
    let cards = [];
    function updateCollections() {
      const prior = collection.value;
      while (collection.options.length > 1) collection.remove(1);
      cards.filter(c => !brand.value || c.dataset.vendor === brand.value)
        .sort((a,b) => a.dataset.title.localeCompare(b.dataset.title))
        .forEach(c => collection.add(option(c.dataset.handle, c.dataset.title)));
      collection.value = [...collection.options].some(o => o.value === prior) ? prior : '';
    }
    function filter(updateURL = true) {
      const term = fold(color.value);
      const inScope = card => (!brand.value || card.dataset.vendor === brand.value) &&
        (!collection.value || card.dataset.handle === collection.value);
      // An exact SKU takes precedence over prefix matches (BB-I must not also mean BB-II).
      const exactSKU = !!term && cards.some(card => inScope(card) &&
        [...card.querySelectorAll('[data-variant]')].some(row => fold(row.dataset.sku) === term));
      let collections = 0, colors = 0;
      cards.forEach(card => {
        const scope = inScope(card);
        let matches = 0;
        card.querySelectorAll('[data-variant]').forEach(row => {
          const match = scope && (!term || (exactSKU ? fold(row.dataset.sku) === term :
            fold(row.dataset.colorName).includes(term) || fold(row.dataset.sku).includes(term)));
          row.hidden = !match;
          if (match) matches++;
        });
        card.hidden = matches === 0;
        card.querySelector('[data-color-count]').textContent = String(matches);
        card.querySelector('details').open = matches > 0 && (!!term || !!collection.value);
        if (matches) { collections++; colors += matches; }
      });
      empty.hidden = collections !== 0;
      status.textContent = root.dataset.ready.replace('{collections}', collections).replace('{colors}', colors);
      if (updateURL) {
        const url = new URL(window.location.href);
        [['wfod_brand',brand.value],['wfod_collection',collection.value],['wfod_color',color.value]].forEach(([key,value]) => {
          if (value) url.searchParams.set(key,value); else url.searchParams.delete(key);
        });
        url.searchParams.delete('page');
        history.replaceState(null,'',url);
      }
    }
    async function load() {
      try {
        if (Number(root.dataset.total) > 25000) throw new Error('Shopify pagination limit');
        const documents = [];
        const seen = new Set();
        let page = root, url = null;
        if (Number(root.dataset.page) !== 1) {
          url = new URL(window.location.href);
          url.searchParams.set('page','1');
        }
        while (true) {
          if (url) {
            url.searchParams.set('section_id',root.dataset.sectionId);
            // Search is client-side only. Do not send stale discovery state to Shopify pagination.
            ['wfod_brand','wfod_collection','wfod_color'].forEach(key => url.searchParams.delete(key));
            if (preview) url.searchParams.set('preview_theme_id',preview);
            const key = url.toString();
            if (seen.has(key)) throw new Error('Repeated pagination page');
            seen.add(key);
            const controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(),15000);
            let response;
            try { response = await fetch(url,{signal:controller.signal,credentials:'same-origin'}); }
            finally { clearTimeout(timeout); }
            if (!response.ok) throw new Error('Collection page unavailable');
            const doc = new DOMParser().parseFromString(await response.text(),'text/html');
            page = doc.querySelector(selector);
            if (!page || Number(page.dataset.total) !== Number(root.dataset.total)) throw new Error('Collection changed or incomplete response');
          }
          documents.push(...page.querySelectorAll('[data-product]'));
          if (documents.some(c => c.hasAttribute('data-variants-incomplete'))) throw new Error('Variant pagination requires product page');
          const next = page.dataset.next;
          if (!next) break;
          url = new URL(next, locationURL);
          if (url.origin !== locationURL.origin) throw new Error('Unexpected pagination origin');
          url.searchParams.set('view','discovery');
        }
        const unique = new Set(documents.map(c => c.dataset.product));
        if (unique.size !== Number(root.dataset.total) || unique.size !== documents.length) throw new Error('Incomplete catalog');
        cards = documents;
        const fragment = document.createDocumentFragment();
        cards.forEach(card => fragment.appendChild(card));
        results.replaceChildren(fragment);
        preservePreview(results);
        const vendors = currentVendor ? brandRoutes.map(a => a.dataset.brandRoute).filter(Boolean) : [...new Set(cards.map(c => c.dataset.vendor))];
        vendors.sort((a,b)=>a.localeCompare(b)).forEach(v => brand.add(option(v,v)));
        brand.value = currentVendor;
        if (!currentVendor && [...brand.options].some(o => o.value === locationURL.searchParams.get('wfod_brand'))) brand.value = locationURL.searchParams.get('wfod_brand');
        updateCollections();
        if ([...collection.options].some(o => o.value === locationURL.searchParams.get('wfod_collection'))) collection.value = locationURL.searchParams.get('wfod_collection');
        color.value = locationURL.searchParams.get('wfod_color') || '';
        controls.querySelectorAll('input,select,button').forEach(el => el.disabled = false);
        pagination.hidden = true;
        root.dataset.complete = 'true';
        root.dataset.loadedProducts = cards.length;
        root.dataset.loadedVariants = cards.reduce((n,c) => n+c.querySelectorAll('[data-variant]').length,0);
        brand.addEventListener('change',()=>{
          if (currentVendor && brand.value !== currentVendor) {
            const route = brandRoutes.find(a => a.dataset.brandRoute === brand.value);
            if (route) { window.location.assign(route.href); return; }
          }
          collection.value='';updateCollections();filter();
        });
        collection.addEventListener('change',()=>filter());
        color.addEventListener('input',()=>filter());
        reset.addEventListener('click',()=>{brand.value=currentVendor;collection.value='';color.value='';updateCollections();filter();brand.focus();});
        filter(false);
      } catch (error) {
        root.dataset.complete = 'false';
        controls.hidden = true;
        root.querySelector('[data-error-message]').hidden = false;
        status.textContent = '';
        // Original paginated server-rendered cards and links are intentionally retained.
      } finally {
        root.removeAttribute('aria-busy');
      }
    }
    load();
  }
  function initAll(scope = document) { scope.querySelectorAll(selector).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>initAll()); else initAll();
  document.addEventListener('shopify:section:load',event => initAll(event.target));
})();
